// extracted by mini-css-extract-plugin
module.exports = {"mainContentWrap":"layout-module--mainContentWrap--MVTfW","nonFluid":"layout-module--nonFluid--2g4Sb"};